// extracted by mini-css-extract-plugin
module.exports = {"container":"HomePage_container__2fACu","green":"HomePage_green__iHZkk","circle-part":"HomePage_circle-part__1Fn3k"};